"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _Icon = _interopRequireDefault(require("../../Icon"));

var _constants = require("../../Icon/constants");

var _Tooltip = _interopRequireDefault(require("../../Tooltip"));

var _utils = require("../../../utils");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function CellTooltiped(props) {
  var value = _typeof(props) === 'object' ? props.value : props;
  var showTooltip = value.length > props.maxLength;
  var className = (0, _utils.getClassNames)('table-cell_tooltipped', {
    'table-cell_tooltipped-show': showTooltip
  });
  var trimmedValue = value.length > props.maxLength ? "".concat(value.substring(0, props.maxLength), "...") : value;
  return /*#__PURE__*/_react.default.createElement("span", {
    className: className
  }, /*#__PURE__*/_react.default.createElement("span", null, trimmedValue), showTooltip && /*#__PURE__*/_react.default.createElement(_Tooltip.default, {
    title: value,
    overlayClassName: "ant-tooltip-table",
    className: "table-tooltip",
    trigger: "click"
  }, /*#__PURE__*/_react.default.createElement(_Icon.default, {
    className: "icon__tooltipped",
    size: 10,
    type: _constants.ICON_TYPE_TOOLTIP
  })));
}

CellTooltiped.propTypes = {
  value: _propTypes.default.string,
  maxLength: _propTypes.default.number
};
CellTooltiped.defaultProps = {
  value: null,
  maxLength: 20
};
var _default = CellTooltiped;
exports.default = _default;